<template>
    <div class="card-wrap">
        <div class="card-header">
            <Row>
                <Col :span="1" style="width: 25px;"> <Icon type="md-arrow-dropright-circle" size="20"/></Col>
                <Col style="text-align: left;padding-top: 2px;font-weight: bold">{{title}}</Col>
            </Row>
        </div>
        <div class="card-extra" v-if="$slots.extra">
            <slot name="extra"></slot>
        </div>
        <div class="card-body">
            <slot></slot>
        </div>
    </div>
</template>
<style lang="less" scoped>
    @import "../pages/common/mui";
    .card-wrap{
        position: relative;

        & .card-header{
            height: 40px;
            line-height: 40px;
            padding: 0 16px;
            font-size: 16px;
            background-color:@color-main;
            color: white;
            border-bottom: none;
        }
        & .card-extra{
            position: absolute;
            top:11px;
            right: 16px;
            & *{
                color: white;
            }
        }
        &.headBack{
            & .card-header{
                background-color:@color-main;
                color: white;
                border-bottom: none;
            }
            & .card-extra{
                & *{
                    color: white;
                }
            }
        }
    }
</style>
<script>
    export default {
        name:'v-card',
        data() {
            return {
            }
        },
        props:['title','headBack'],
        components: {}
    }
</script>
